import { AxiosError } from 'axios'
import { TStatusCode } from './Interfaces'

/**
 * Determines whether param `candidate` is of TS type `AxiosError`
 */
export function isAxiosError(candidate: any): candidate is AxiosError {
  return !!candidate.isAxiosError
}

/**
 * Determines whether status code is of 2XX type.
 */
export function is2XX(statusCode: TStatusCode) {
  return statusCode.toString()[ 0 ] == '2'
}

/**
 * Determines whether status code is of 3XX type.
 */
export function is3XX(statusCode: TStatusCode) {
  return statusCode.toString()[ 0 ] == '3'
}

/**
 * Determines whether status code is of 4XX type.
 */
export function is4XX(statusCode: TStatusCode) {
  return statusCode.toString()[ 0 ] == '4'
}

/**
 * Determines whether status code is of 5XX type.
 */
export function is5XX(statusCode: TStatusCode) {
  return statusCode.toString()[ 0 ] == '5'
}

/**
 * Takes an object to produce a string of format:
 * 
 * `?firstKey=firstValue&secondKey=secondValue&...`.
 */
export function getQueryStringFromObj(obj: { [k: string]: string }): string {
  let keyValTuples = Object.entries(obj)
  if (keyValTuples.length == 0) return ''
  return '?' + keyValTuples.map(([key, val]) => `${key}=${val}`).join('&')
}

/**
 * "Resolves" slash conflicts in multiple strings
 * that need to be joined with single slashes between them,
 * as long as there are no duplicate or more slashes consecutively
 * in a single string.
 * 
 * (Just the bordering slashes are taken care of)
 * 
 * Undefined values get ignored.
 */
export function joinWithSlashes(...args: (string | undefined)[]): string {
  let productSt = ''

  for (let i = 0; i < args.length; ++i) {
    let st = args[ i ]
    if (st == null) continue

    // Make sure that the string has no starting bordering slash
    if (st.charAt(0) == '/') st = st.substr(1)

    // Remove last position character, if it is a slash
    if (st.charAt(st.length - 1) == '/') st = st.substring(0, st.length - 1)

    productSt += st

    // Because we're going to be adding it right here
    // (if it is not the last string)
    if (i != args.length - 1) productSt += '/'
  }

  return productSt
}
